import React, { useState } from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './ui/tooltip';

function ClickCopyText({ displayText, copyText }) {
    const [tooltipVisible, setTooltipVisible] = useState(false); // State to control tooltip visibility

    // Handle copy and display the tooltip
    const handleCopy = () => {
        navigator.clipboard.writeText(copyText)
            .then(() => {
                setTooltipVisible(true); // Show tooltip
                // Hide tooltip after 2 seconds
                setTimeout(() => {
                    setTooltipVisible(false);
                }, 2000);
            })
            .catch(err => {
                console.error('Error copying text: ', err);
            });
    };

    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>
                    <div 
                        onClick={handleCopy}
                        className="cursor-pointer text-gray-500 hover:text-blue-500"
                    >
                        {displayText}
                    </div>
                </TooltipTrigger>
                {tooltipVisible && (
                    <TooltipContent side="bottom" align="end" className="flex bg-primary items-center gap-4 mb-10">
                        Copied
                    </TooltipContent>
                )}
            </Tooltip>
        </TooltipProvider>
    );
}

export default ClickCopyText;
